export default "__VITE_ASSET__C2e9gREz__"